import { Eye, ShieldCheck, Users, Star } from "lucide-react";

const reasons = [
  {
    icon: Eye,
    title: "Obsessive Attention to Detail",
    description: "Every crevice, every panel, every surface is inspected and perfected. We don't cut corners — ever.",
    span: "md:col-span-6 md:row-span-2",
    featured: true,
  },
  {
    icon: ShieldCheck,
    title: "Premium Products Only",
    description: "We use only the highest-grade, pH-balanced products and professional equipment.",
    span: "md:col-span-6",
  },
  {
    icon: Users,
    title: "Local & Trusted",
    description: "Proudly serving the Sammamish community. We've built our reputation on trust and results.",
    span: "md:col-span-6",
  },
  {
    icon: Star,
    title: "Satisfaction Guaranteed",
    description: "If you're not completely satisfied, we'll make it right. Your happiness is our benchmark.",
    span: "md:col-span-12",
  },
];

export default function WhyUsSection() {
  return (
    <section id="why-us" data-testid="why-us-section" className="py-24 md:py-32 bg-[#141414]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#737373] mb-4">The Difference</p>
          <h2
            data-testid="why-us-heading"
            className="text-3xl sm:text-4xl tracking-tight font-bold uppercase text-white"
          >
            Why Choose Us
          </h2>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {reasons.map((reason, i) => {
            const Icon = reason.icon;
            return (
              <div
                key={reason.title}
                data-testid={`why-us-card-${i}`}
                className={`border border-[#262626] bg-[#0A0A0A] bento-card ${reason.span} ${
                  reason.featured ? "p-10 md:p-12 flex flex-col justify-between" : "p-8"
                }`}
              >
                <div>
                  <div className="w-10 h-10 flex items-center justify-center border border-[#333333] mb-6">
                    <Icon size={20} className="text-[#A3A3A3]" />
                  </div>
                  <h3 className={`${reason.featured ? "text-2xl sm:text-3xl" : "text-xl"} font-semibold tracking-tight text-white mb-3`}>
                    {reason.title}
                  </h3>
                </div>
                <p className={`${reason.featured ? "text-base" : "text-sm"} leading-relaxed text-[#A3A3A3]`}>
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
